module.exports = __webpack_public_path__ + "static/media/matilde-hat-greece-scary.7f2dc91f.png";